module.exports = __webpack_public_path__ + "static/work41-6a587f6de9cb813c4557834788b1d223.jpg";